<script>
    import { createEventDispatcher } from 'svelte'
    import { get } from 'dot-prop'
    import { FormGroup, Input, Label } from 'sveltestrap'
    import Required from './Required.svelte'
    import ValidationMessage from './ValidationMessage.svelte'

    export let context
    export let formKey
    export let index
    export let keypath // The keypath without the formKey or index, e.g. "attributes.videos.3.url"
    export let label
    export let required
    export let helptext
    export let value

    $: formKeypath = index === undefined ? `${formKey}.${keypath}` : `${formKey}.${index}.${keypath}`
    $: isInvalid = get(context, `error.${formKeypath}.level`) === 'error'

    const dispatch = createEventDispatcher()
    const update = (event) => {
        dispatch('change', { formKey, index, keypath, value: event.target.checked, context })
    }
</script>

<FormGroup check>
    <Label check>
        {label || ''}
        <Required {required} />
    </Label>

    <Input
        type="checkbox"
        id={formKeypath}
        name={formKeypath}
        {isInvalid}
        bind:checked={value}
        on:change={update}
        on:blur
    />

    <ValidationMessage {context} {formKeypath} {helptext} />
</FormGroup>
